module.exports = __webpack_public_path__ + "static/assets/83f2d48d0c7d1e6be8a509d4d2c6d0e5.mp3";